import axios from '../../axios.js'

export default {
  fetchRecords({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/customer-groups", {
          params: payload
        })
        .then(response => {
          commit("SET_CUSTOMER_GROUP", response.data);
          commit("SET_PAGINATION", {
            currentPage: response.headers["x-pagination-page"],
            totalPage: response.headers["x-pagination-page-count"],
            pageTotal: response.headers["x-pagination-count"],
            totalItem: response.headers["x-pagination-total"]
          });

          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchRecord ({commit}, groupId) {
    let arrayResponse = [];
    return new Promise((resolve, reject) => {
      axios.get(`/customer-groups/${groupId}`)
        .then((response) => {
          arrayResponse.push(response.data);
          commit("SET_CUSTOMER_GROUP", arrayResponse);
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  // eslint-disable-next-line no-unused-vars
  addRecords({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios.post("/customer-groups/bulk", {"bulk" : items})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addRecord({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/customer-groups", item)
        .then((response) => {
          commit('ADD_CUSTOMER_GROUP', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateRecord({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put("/customer-groups/" + item.groupId, item)
        .then((response) => {
          commit('UPDATE_CUSTOMER_GROUP', response.data)
          resolve(response)
        })
        .catch((error) => { console.log(error); reject(error); })
    })
  },
  removeRecord ({ commit }, groupId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/customer-groups/${groupId}`)
        .then((response) => {
          commit('DELETE_CUSTOMER_GROUP', groupId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
};
